// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item[data-v-20613457] {
  --background: #f9b000 !important;
}
ion-item ion-icon[data-v-20613457] {
  color: white !important;
}
ion-item ion-label[data-v-20613457] {
  color: white !important;
}
ion-item ion-label p[data-v-20613457] {
  color: white !important;
}
.ion-palette-dark ion-item[data-v-20613457] {
  --background: #f9b000 !important;
}
.ion-palette-dark .email-color[data-v-20613457] {
  color: white !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
